module.exports = __webpack_public_path__ + "static/img/icon_jinggao@2x.62eb3acb.png";